import { render, staticRenderFns } from "./ExpectedLoanRepayments.vue?vue&type=template&id=3aabd50e"
import script from "./ExpectedLoanRepayments.vue?vue&type=script&lang=js"
export * from "./ExpectedLoanRepayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports